<div class="container">
  <div class="header">
    <div class="page_title_close_btn">
      <div class="close_btn" (click)="goBack()">
        <img src="assets/icons/close_icon.svg" alt="close icon" />
      </div>
      <div class="page_title">
        @if (readOnlyMode) {
          View
        } @else if (editingEnabled) {
          Edit
        } @else {
          Create
        }
        Role
      </div>
    </div>

    <div class="save_cancel_btn">

      @if (!readOnlyMode) {

        <!--        <button class="secondary_button" (click)="reset()">Reset</button>-->
        <button class="secondary_button" (click)="goBack()">Cancel</button>
        <button class="primary_button add_new_btn" (click)="save()">
        <span>
          @if (editingEnabled) {
            Update
          } @else {
            Save
          }
        </span>
        </button>
      } @else {
        <button class="secondary_button add_new_btn" (click)="goBack()">Go Back</button>
      }
    </div>
  </div>
  <div class="content">
    <div class="full_Card">
      <form [formGroup]="rolesForm">
        <div class="form-row">
          <div class="form-group">
            <label for="name" class="required_field_label">Role Name</label>
            <input type="text" id="name" [formControlName]="'name'" placeholder="Enter Role Name"
                   [ngClass]="{ 'form_error': rolesForm.get('name')?.invalid && rolesForm.get('name')?.touched }">

            <div
              class="form_validation_error"
              [ngClass]="{'form_error': rolesForm.get('name')?.invalid && rolesForm.get('name')?.touched}"
            >
              <small *ngIf="rolesForm.get('name')?.errors?.['required']"
              >Role Name is required</small
              >
            </div>

          </div>
          <div class="form-group">
            <label for="description" >Description</label>
            <input type="text" id="description" [formControlName]="'description'" style="width: 584px"
                      placeholder="Enter Role Description" />
          </div>
        </div>
      </form>
    </div>
    <app-item-selector-panel
      #itemSelectorComponent
      [listReadOnly]="true"
      [entity]="'PERMISSIONS'"
      [items]="leftPanelData"
      [showLeftPanelCheckBox]="false"
      [itemsTitle]="'Permissions'"
      (onItemSelection)="handlePermissionItemSelection($event)"
    ></app-item-selector-panel>
  </div>

</div>

<ng-template #searchBar let-data>

  <div class="search_bar">
    <div class="search_bar_heading">{{data.permissionName}}</div>
    <div class="search_container">
      <input
        type="text"
        name="search_table"
        id="search_table"
        [(ngModel)]="searchTerm"
        placeholder="Search by name or description"
        (focus)="focusSearch = true"
        (focusout)="focusSearch = false"
        (keyup)="handleTableSearch($event)"
      >
      <img src="assets/icons/search_icon.svg" class="search_icon">
    </div>
  </div>
</ng-template>
